import { render, staticRenderFns } from "./organizations-by-economic-activity-labels.vue?vue&type=template&id=de8496fc&scoped=true&"
import script from "./organizations-by-economic-activity-labels.vue?vue&type=script&lang=js&"
export * from "./organizations-by-economic-activity-labels.vue?vue&type=script&lang=js&"
import style0 from "./organizations-by-economic-activity-labels.vue?vue&type=style&index=0&id=de8496fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8496fc",
  null
  
)

export default component.exports